export default __webpack_public_path__ + "assets/images/f01c4aa99090b1fdf8375be7f183ef9c.png";